import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  // Modal,
  Table,
  Layout,
  Space,
  Row,
  Col,
  Button,
  FloatButton,
} from "antd";
import dayjs from "dayjs";
import {
  PlusCircleOutlined,
  EditOutlined,
  // DeleteOutlined,
  EyeFilled,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";

import { usePaginate } from "backend/usePaginate";
import { useBackend } from "backend/useBackend";
import SearchBy from "components/SearchBy";
import PageLimitDropDown from "components/PageLimitDropDown";
import { DeleteConfirm } from "cms/components/DeleteConfirm";
import TagStatus from "cms/components/TagStatus.js";

var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
const { Content } = Layout;

const endpoint = "quotes";
// const where = ['status', "==", 'initiated']

const List = () => {
  const tableRef = useRef();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [list, setList] = useState([]);
  const { deleteItem } = useBackend();
  const [showMore, setShowMore] = useState(true);

  const { loading, loadingMore, hasMore, items, loadMore, deleteById } =
    usePaginate(endpoint);

  useEffect(() => {
    setList(items);
  }, [items]);

  // console.log(list)

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list);
      setShowMore(false);
    } else {
      setList(items);
      setShowMore(true);
    }
  };

  const columns = [
    // {
    //   title: "Name",
    //   dataIndex: "firstName",
    //   key: "firstName",
    //   // filters: {},
    //   sortDirections: ["ascend", "descend"],
    //   render: (firstName, row) => (
    //     <span>
    //       {firstName} {row?.lastName}
    //     </span>
    //   ),
    // },
    // {
    //   // searchable: true, // this is used for searchBy component
    //   title: "Title",
    //   dataIndex: "title",
    //   key: "title",
    //   // filters: {},
    //   // sorter: true,
    //   responsive: ["md"],
    //   // sortDirections: ["ascend", "descend"],
    // },
    {
      searchable: true, // this is used for searchBy component
      title: "Quote",
      dataIndex: "quote",
      key: "quote",
      // filters: {},
      // sorter: true,
      responsive: ["md"],
      // sortDirections: ["ascend", "descend"],
      // render: (quote) => <div>{String(quote).substring(0, 50)}</div>,
      ellipsis: true,
    },
    {
      title: "Likes",
      dataIndex: "like",
      key: "like",
      align: "right",
      responsive: ["md"],
    },
    {
      title: "Views",
      dataIndex: "view",
      key: "view",
      align: "right",
      responsive: ["md"],
    },
    {
      title: "Author",
      dataIndex: ["author", "fullName"],
      key: "title",
      // filters: {},
      // sorter: true,
      responsive: ["md"],
      // sortDirections: ["ascend", "descend"],
    },
    {
      title: "Featured",
      dataIndex: "featured",
      key: "featured",
      responsive: ["md"],
      align: "right",
      render: (featured) =>
        React.createElement(featured ? StarFilled : StarOutlined, {
          style: { color: "gold" },
        }),
    },
    {
      title: "Topics",
      dataIndex: "topics",
      key: "topics",
      responsive: ["md"],
      render: (topics) =>
        topics && topics.map((topic) => topic.name).join(", "),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      responsive: ["md"],
      render: (status) => <TagStatus status={status} />,
    },
    {
      title: "Last Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "right",
      render: (updatedAt) => (
        dayjs(updatedAt).format("L LT")
      ),
    },
    // {
    //   title: "Date",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   align: "right",
    //   render: (createdAt, row) => (
    //     <>
    //       <div>Created: {dayjs(createdAt).format("L LT")}</div>
    //       <div>Update: {dayjs(row.updatedAt).format("L LT")}</div>
    //     </>
    //   ),
    // },
    // {
    //   title: "Created",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (createdAt) => dayjs(createdAt).format("L LT"),
    // },
    // {
    //   title: "Updated",
    //   dataIndex: "updatedAt",
    //   key: "updatedAt",
    //   // render: (updatedAt, row) => updatedAt.toString()
    //   render: (updatedAt) => dayjs(updatedAt).format("L LT"),
    // },
    {
      title: "Actions",
      className: "table-actions",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (id, row) => (
        <Space size="middle">
          <EyeFilled
            onClick={() => navigate(`${pathname}/view/${id}`, { state: row })}
          />
          <EditOutlined
            onClick={() => navigate(`${pathname}/edit/${id}`, { state: row })}
          />
          {/* <DeleteOutlined
            style={{ color: "#ff0000" }}
            onClick={() => deleteConfirm(row)}
          /> */}
          <DeleteConfirm
            onConfirm={() =>
              deleteItem(endpoint, row.id, {
                redirectTo: endpoint,
                msg: {
                  loading: "Deleting...",
                  success: "Deleted successfully.",
                },
                loading: true,
              }).then(() => deleteById(row.id))
            }
          />
        </Space>
      ),
    },
  ];

  const onChange = (data) => {
    console.log(data);
  };

  return (
    <Content>
      <FloatButton
        icon={<PlusCircleOutlined />}
        type="primary"
        tooltip="Add New"
        onClick={() => navigate(`${pathname}/add`)}
      />
      <Row justify="space-between" style={{ marginBottom: "1em" }}>
        <Col xs={18} lg={12}>
          <Space>
            {/* <FilterByDate
              table={endpoint}
              column="transactionAt"
              setResult={setResult}
              stickyCondition={where}
            /> */}
            <SearchBy
              endpoint={endpoint}
              columns={columns}
              setResult={setResult}
            />
          </Space>
        </Col>
        {/* <Col xs={6} lg={12} className="text-right"> */}
        {/* <Link to={`${pathname}/add`}>
            <Button type="primary">Add Item</Button>
          </Link> */}
        {/* </Col> */}
      </Row>
      <Table
        rowKey="id"
        dataSource={list}
        columns={columns}
        loading={loading}
        onChange={onChange}
        pagination={false}
        ref={tableRef}
      />
      <Row justify="space-between" style={{ marginTop: "1.5em" }}>
        <Col>
          <PageLimitDropDown />
        </Col>
        <Col>
          {showMore && hasMore && (
            <Button type="primary" onClick={loadMore} loading={loadingMore}>
              {loadingMore ? "Loading..." : "Load More"}
            </Button>
          )}
        </Col>
      </Row>
    </Content>
  );
};

export default List;
